<template>
  <!-- 投诉单详情 -->
  <el-drawer title="投诉单详情" :visible.sync="show" direction="rtl" destroy-on-close style="padding: 20px;" size="70%" append-to-body>
    <div class="complaint-form-detail-container">
      <!-- 投诉信息 -->
      <div class="complaint-messages">
        <h2>
          投诉信息
          <el-tag type="primary">
            {{ complaintDetail.status_description || '' }}
          </el-tag>
        </h2>
        <el-descriptions title="1、投诉信息">
          <el-descriptions-item :contentStyle="{marginRight: '25px'}" v-for="(item, index) in messages" :key="index" :label="item.label">
            {{ item.value }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 关联交易订单 -->
      <div class="complaint-progress">
        <h2>关联交易订单</h2>
        <BaseTable :data="complaintDetail.complaint_trade_info_list || []" border max-height="300px" :pageSize="10" :columns="releatedOrderColumns" />
      </div>

      <!-- 处理记录 -->
      <div class="complaint-progress">
        <h2>
          处理记录
          <!-- 处理中、待处理、超时未处理可以回复 -->
          <el-link v-if="['PROCESSING', 'WAIT_PROCESS', 'OVERDUE'].includes(complaintDetail.status)" type="primary" :underline="false" style="margin-left: 10px;" @click="handleReplayUser">回复用户</el-link>
        </h2>
        <BaseTable :data="historyList" :loading="historyLoading" border :columns="historyColumns" max-height="300px" />
      </div>
      
      <el-alert title="必须在工单后台回复用户，才能获取到完整的处理记录；若对记录有疑问，可结合支付宝商户号后台查看后处理，并反馈产研。" :closable="false" type="warning" show-icon></el-alert>
    </div>


    <!-- 回复用户 -->
    <ReplyUser ref="replyUser" @success="handleGetRecords" />
  </el-drawer>
</template>

<script>
import BaseTable from '@/components/common/BaseTable/index.vue';
// 回复用户
import ReplyUser from './replyUser.vue';
import { getZfbComplaintDetailApi, handleZfbComplaintRecordsApi } from '@/api/merchant_complain_handle';
import { cloneDeep } from 'lodash'
import { complaintStatusOptions } from './processCompleted.vue'

export default {
  name: 'WxComplaintFormDetail',
  components: {
    BaseTable,
    ReplyUser
  },
  data () {
    return {
      complaintStatusOptions,
      show: false,
      messages: [
        { label: '支付金额', field: 'complain_amount', value: '' },
        { label: '投诉内容', field: 'complain_content', value: '' },
        { label: '联系方式', field: 'contact', value: '' },
        { label: '投诉网站', field: 'complain_url', value: '' },
        { label: '商户ID', field: 'merchant_id', value: '' },
        { label: '投诉单号', field: 'task_id', value: '' },
        { label: '推送时间', field: 'gmt_risk_finish_time', value: '' },
        { label: '投诉时间', field: 'gmt_complain', value: '' },
      ],
      // 处理记录
      historyLoading: false,
      historyList: [],
      complaintDetail: {},
      merchantData: {
        id: '', // 商户号ID
        complain_id: '' // 记录ID
      },
    }
  },
  computed: {
    releatedOrderColumns () {
      return [
        {
          label: '支付宝交易单号',
          key: 'trade_no',
        },
        {
          label: '交易单号',
          key: 'out_no',
        },
        {
          label: '支付金额(元)',
          key: 'amount',
        },
        {
          label: '状态',
          key: 'status_description',
        },
        {
          label: '交易时间',
          key: 'gmt_trade',
        },
      ]
    },
    historyColumns () {
      return [
        {
          label: '时间',
          key: 'created_at',
          width: 150
        },
        {
          label: '操作',
          key: 'log_type_str',
        },
        {
          label: '内容',
          key: 'content',
          'show-overflow-tooltip': false,
          render: (h, params) => {
            const { content = '', deal_res = '' } = params.row
            const target = this.complaintStatusOptions.find(it => it.value === deal_res) || {}
            return (
              <div>
                {
                  !!deal_res && <div>
                    处理结论：{ target.label }
                  </div>
                }
                <el-tooltip content={content} placement="top">
                  <div style="max-width: 400px;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">
                  { !!deal_res && <span>补充说明：</span> }
                  { content }
                </div>
                </el-tooltip>
                
              </div>
            )
          }
        },
        {
          label: '回复用户（对客展示）',
          key: 'reply_content',
          'show-overflow-tooltip': false,
          render: (h, params) => {
            const { reply_content = '' } = params.row
            return (
              <el-tooltip content={reply_content} placement="top">
                <div style="max-width: 400px;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">
                  { reply_content || '-' }
                </div>
              </el-tooltip>
            )
          }
        },
        {
          label: '图片',
          key: 'img_list',
          width: 270,
          render: (h, params) => {
            const { img_list = [] } = params.row
            return (
              <div>
                {
                  img_list.map(it => {
                    return <el-image src={it} style="width: 50px; height: 50px;margin-right: 10px" fit="contain" preview-src-list={img_list}></el-image>
                  })
                }
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    triggleVisible (data) {
      this.merchantData = data
      getZfbComplaintDetailApi(data).then(res => {
        const { data } = res.data
        this.complaintDetail = cloneDeep(data)
        this.messages = this.messages.map(item => {
          return {
            ...item,
            value: this.complaintDetail[item.field] || '-'
          }
        })
        this.show = true
        this.handleGetRecords()
      }).catch(() => {})
    },

    // 客诉留言
    handleReplayUser () {
      this.$refs.replyUser.triggleVisible(this.merchantData);
    },

    // 获取处理记录
    handleGetRecords () {
      this.historyLoading = true
      handleZfbComplaintRecordsApi(this.merchantData).then(res => {
        const { data = [] } = res.data
        console.log('data',  res)
        this.historyList = data || []
        this.historyLoading = false
      }).catch(() => { this.historyLoading = false })
    }
  }
}

</script>

<style lang="scss" scoped>

.complaint-form-detail-container {
  padding: 20px;

  .el-descriptions {
    margin: 20px 0;
  }

  .complaint-progress {
    margin-bottom: 20px;
    h2 {
      margin-bottom: 10px;
    }
  }
}
</style>
